/* eslint-disable react/prop-types */
import React from 'react'
import Modal from 'react-modal'
import { useTranslation } from 'react-i18next'

import Loader from '../../../common/loader/legacy-loaders/Op36Loader-web'

import SinglePhotoUploader from '../singlePhotoUploader/SinglePhotoUploader'

import './ImageBankModal.scss'
import { MAX_SELECTED_ADS } from '../../ProShopDisplay'

const MAX_UPLOADS = 10

const ImageBankModal = props => {
  const { t } = useTranslation()
  // This is what the user sees if the bank is empty
  let uploadedImages = []
  const emptyMessage = (
    <p className='image-bank-modal-empty-message'>
      {t('proShop.imageBankModal.emptyMessage')}
    </p>
  )
  const emptyBankDisplay = props.uploads.length <= 0 ? { display: 'flex' } : {}

  // If the bank has at least one image, display bank contents
  if (props.uploads.length > 0) {
    uploadedImages = props.uploads.map(img => {
      const imgSelected = props.selected.includes(img.id)
      const selectedClass = imgSelected
        ? ' image-bank-modal-photo-selected'
        : ''

      // key should be img.id and not index because when a new photo is added,
      // index causes the last uploaded photo to briefly flicker in its place
      return (
        <button
          key={img.id}
          className={'image-bank-modal-photo' + selectedClass}
          onClick={
            props.deletingLoader === img.id
              ? false
              : () => props.selectPhoto(imgSelected, img)
          }
        >
          {props.deletingLoader === img.id && (
            <i
              className='fa fa-spinner fa-spin delete-spinner'
              aria-hidden='true'
            />
          )}
          <div className='image-bank-modal-photo-selected-overlay'>
            {imgSelected ? (
              <div className='image-bank-modal-photo-selected-check'>
                <i className='fa fa-check' aria-hidden='true' />
              </div>
            ) : (
              <div className='image-bank-checkmark-circle-outline' />
            )}
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
            <div
              className='image-bank-delete-button'
              onClick={
                props.deletingLoader === img.id
                  ? false
                  : e => props.deletePhoto(img.id, e)
              }
              onKeyDown={(e) =>
                e.key === 'Enter' &&
                props.deletingLoader === img.id
                  ? false
                  : e => props.deletePhoto(img.id, e)
              }
            >
              <i
                className='fa fa-trash'
                aria-hidden='true'
              />
            </div>
          </div>
          <img
            className='image-bank-modal-photo-thumbnail'
            src={img.large_file_url}
            alt={t('proShop.imageBankModal.uploadedImageAlt')}
          />
        </button>
      )
    })
  }

  return (
    <Modal
      isOpen
      contentLabel={t('proShop.imageBankModal.contentLabel')}
      onRequestClose={props.closeModal}
      className='customModal'
    >
      <div className='image-bank-modal'>
        <div className='image-bank-modal-header'>
          <button className='x-modal-close-btn' onClick={props.closeModal}>
            <i className='fa fa-times' aria-hidden='true'></i>
          </button>
          <h1>{t('proShop.imageBankModal.title', { max: MAX_SELECTED_ADS })}</h1>
          <h2>
            {t('proShop.imageBankModal.reorderHint')}
          </h2>

          {/*
            <button
              className='btn-rectangular btn-rectangular-secondary-positive'
              disabled={props.uploads.length >= MAX_UPLOADS}>+ Upload images</button>
          */}

          <hr />
          <div className='image-bank-upload-button-wrapper'>
            <SinglePhotoUploader
              sendPhotoData={props.sendPhotoData}
              disableUploadBtn={props.uploads.length >= MAX_UPLOADS}
            />
            <p>{t('proShop.imageBankModal.storageHint', { max: MAX_UPLOADS })}</p>
          </div>
        </div>
        <p className='image-bank-modal-num-selected'>
          {t('proShop.imageBankModal.imagesSelected', {
            selected: props.selected.length,
            max: MAX_SELECTED_ADS,
          })}
        </p>
        <div className='image-bank-modal-images' style={emptyBankDisplay}>
          {/*<p>Images selected: {props.selected.length} / 3</p>*/}
          {props.uploading && (
            <div className='image-bank-modal-photo'>
              <Loader />
            </div>
          )}
          {uploadedImages}
          {uploadedImages.length > 0 || props.uploading ? null : emptyMessage}
        </div>
        <div className='image-bank-modal-footer'>
          <button
            className='btn-rectangular btn-rectangular-main-negative'
            onClick={props.closeModal}
          >
            {t('common.cancel')}
          </button>
          <button
            className='btn-rectangular btn-rectangular-main-positive'
            onClick={props.saveSelection}
          >
            {t('common.action.confirm')}
          </button>
        </div>
      </div>
    </Modal>
  )
}

export default ImageBankModal
